module.exports = __webpack_public_path__ + "img/email.9b985edb.svg";